module.exports = `${require.publicPath}logo.44447910.png`;